import { useMutation } from '@tanstack/react-query';

import { type ConfirmOrderResult, confirmOrder } from 'entities/chat/api/chatClient';

type ConfirmOrderVars = {
  previewToken: string;
  idempotencyKey: string;
  threadId?: string | null;
};

// Places a previewed order. confirmOrder returns a Result (never throws), so the ok/error outcome
// is in the mutation's data; isPending drives the button's in-flight state.
export function useConfirmOrder() {
  return useMutation<ConfirmOrderResult, Error, ConfirmOrderVars>({
    mutationFn: ({ previewToken, idempotencyKey, threadId }) => confirmOrder(previewToken, idempotencyKey, threadId),
  });
}
